"use client";

/**
 * P9-07 · One debounced-value hook for every search-as-you-type / filter input.
 * The same six-line implementation had been copy-pasted across the search
 * overlay and four admin list pages; this is the single source of truth. The
 * returned value trails `value` by `ms`, resetting the timer on each change, so
 * a burst of keystrokes yields one settled value.
 */
import * as React from "react";

export function useDebouncedValue<T>(value: T, ms: number): T {
  const [debounced, setDebounced] = React.useState(value);
  React.useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), ms);
    return () => clearTimeout(timer);
  }, [value, ms]);
  return debounced;
}
